import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  ActionType,
  IMiniStressLastNotificationTimeResponse,
} from "models/stressCheck/miniStressLastNotificationTime";
import { httpStatus } from "configs/httpStatus";
import { getMiniStressLastNotificationTime } from "services/stressCheck";
import {
  handleSuccesAction,
  handleErrorAction,
} from "./miniStressLastNotificationTimeActions";

function* miniStressLastNotificationTimeSaga() {
  try {
    const response: IMiniStressLastNotificationTimeResponse = yield call(
      getMiniStressLastNotificationTime
    );
    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccesAction(response));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onGetMiniStressLastNotificationTimeWatcher() {
  yield takeLatest(
    ActionType.MINI_STRESS_LAST_NOTIFICATION_TIME as any,
    miniStressLastNotificationTimeSaga
  );
}

export default [fork(onGetMiniStressLastNotificationTimeWatcher)];
